import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import CompleteDataCollectedImage from './CompleteDataCollectedImage'

const copy = {
  heading: `Complete data collected across the entire customer journey`,
}

const CompleteDataCollected: FC<PropsWithChildren<unknown>> = () => {
  return (
    <Wrapper>
      <StyledSection variant="centered">
        <Section.Copy>
          <CopyTextBase centered={true}>
            <CopyText.Heading variant="h2" tag="h2">
              {copy.heading}
            </CopyText.Heading>
          </CopyTextBase>
        </Section.Copy>
        <Section.Contents>
          <CompleteDataCollectedImage />
        </Section.Contents>
      </StyledSection>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  ${({ theme }) => theme.breakpoints.up(`md`)} {
    padding-top: 80px;
  }
`

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    ${({ theme }) => theme.breakpoints.down(`md`)} {
      row-gap: 40px;
    }
    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      padding-top: 10px;
    }
  }
`

export default CompleteDataCollected
